import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import AddFormModal from "../../../../Components/Modal/supplier_app/AddFormModal";

import Loader from "../../../../Components/Loader";

import { useNavigate, useLocation } from "react-router-dom";
import isEqual from 'lodash/isEqual';

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import CreateRFQSuppliers from "../../../../Components/Modal/supplier_app/Sourcing/CreateRFQSuppliers";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import {
  checkTimeDifference,
  isValidNumber,
} from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import { MultiselectField } from "../../../../Components/formElements/MultiselectField";
import {
  addDynamicFormDataCOMM,
  addDynamicFormDataTECH,
  getRfqQuotation,
} from "../../../../redux/feature/supplier_app/sourcingSlice";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { ComboboxField3, ComboboxField4 } from "../../../../Components/formElements/ComboboxField";


// Ordered wizard steps for the manual RFQ page. The header tabs, tab panels
// and the Previous / Next buttons all key off this single list so the order
// stays in sync. The Commercial / Technical questionnaires share a single
// "Tech & Comm Template" tab (same as the Create RFQ tabs page) and the
// Create Manual RFQ button stays in the footer.
const tabList = [
  { id: "rfq-title", label: "RFQ Title" },
  { id: "configuration", label: "Configuration" },
  { id: "line-items", label: "Line Items" },
  { id: "suppliers", label: "Suppliers" },
  { id: "tech-comm", label: "Tech & Comm Template" },
  { id: "schedule", label: "Schedule" },
];

const CreateManualRFQ = () => {

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const { draftId: draftIdParam, newDraft: newDraftParam } = location.state || {};

  let rfxCategoryType = useSelector((state) => state?.sourcing.purchaseDocType);
  let rfxCategoryCode = useSelector((state) => state?.sourcing.purchaseDocCode);
  let rfxCategoryDescription = useSelector(
    (state) => state?.sourcing.purchaseDocDescription
  );
  let rfqCreation = useSelector((state) => state?.sourcing.rfqCreation);
  let approvedSelectedRows = useSelector(
    (state) => state?.sourcing.purchase_requisition.approvedSelectedRows
  );
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  let config = useSelector((state) => state?.common?.data?.sourcing); // Common Details from Store

  // let dynamicFormDataStatus = useSelector(
  //   (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataStatus
  // ); // purchase_requisition from Store

  let dynamicFormDataCOMM = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataCOMM
  ); // purchase_requisition from Store
  let dynamicFormDataTECH = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataTECH
  ); // purchase_requisition from Store

  let dropdownOption = [
    {
      id: "1",
      name: "Sample Data 1",
    },
    {
      id: "2",
      name: "Sample Data 2",
    },
  ];
  let reminderDropDown = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  // ========== DRAFT: State & Refs ==========
  const [draftData, setDraftData] = useState(null);
  const previousFormInputsRef = useRef(null);
  const isFirstAutoSave = useRef(true);
  const draftDataRef = useRef(null);
  const DRAFT_DOCUMENT_TYPE = "MANUAL_RFQ"; // or "RFQ" depending on backend
  const [loadingDrafts, setLoadingDrafts] = useState(true);


  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  const [isCardVisibleCS, setCardVisibleCS] = useState(true);

  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [editorContent, setEditorContent] = useState("");
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [getRFxType, setRFxType] = useState([]);
  const [getRFxProductType, setRFxProductType] = useState([]);
  const [getRfxPurchaseType, setRfxPurchaseType] = useState([]);
  const [getRfxBidType, setRfxBidType] = useState([]);
  const [getCompanyAddress, setCompanyAddress] = useState([]);
  const [getBillingAddress, setBillingAddress] = useState([]);
  const [getDeliveryAddress, setDeliveryAddress] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getTechnicalApprovalType, setTechnicalApprovalType] = useState([]);
  const [getRfxNoOfEvaluationType, setRfxNoOfEvaluationType] = useState([]);
  const [getPlant, setPlant] = useState([]);


  const [getTechnicalUserList, setTechnicalUserList] = useState([]);

  const [getLineItemData, setLineItemData] = useState([]);
  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  const [getFormModalData, setFormModalData] = useState({});
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [getChargesSelection, setChargesSelection] = useState([]);
  const [getChargesSelected, setChargesSelected] = useState([]);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  const [subTotalValue, setSubTotalValue] = useState(0);

  // const [answers, setAnswers] = useState({});
  const [localFormDataCOMM, setLocalFormDataCOMM] = useState([]);
  const [localFormDataTECH, setLocalFormDataTECH] = useState([]);


  const [formInputs, setFormInputs] = useState({
    rfxType: "",
    productType: "",
    rfxValue: "",
    rfxHeaderStatus: "RFQ Created",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    companyAddress: "", //i did'nt get in json
    rfxVersion: "V0",
    buyerEmail: userData?.email,
    initiatorName: userData?.firstName,
    initiator: userData?.userId,
    buyerResponsible: userData?.userId,
    createdOn: "", //i did'nt get in json
    buyerConact: userData?.contactNumber,
    deliveryAddressCodeDesc: "",
    rfxCategoryType: rfxCategoryType,
    rfxCategoryCode: rfxCategoryCode,
    rfxCategoryDesc: rfxCategoryDescription,
    rfqCreation: rfqCreation,
    rfxTitle: "",
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: "",
    headerIncoTerms: "",
    incoTermsLocation: "",
    procurementStrategies: "",

    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
  });

  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour: "",
    status: false,
    msg: "",
  });


  // ========== DRAFT: Helper functions ==========
  const createEmptyFormInputs = () => ({
    ...formInputs, // start with current shape
    // include all separate states as fields
    lineItems: [],
    suppliers: [],
    termsConditions: [],
    editorContent: "",
    dynamicFormDataCOMM: [],
    dynamicFormDataTECH: [],
    chargesSelected: [],
    openCloseInput: {
      openingDate: "",
      openingTime: "",
      closingDate: "",
      closingTime: "",
      totalHour: "",
      status: false,
      msg: "",
    },

    // answers: {},   // <-- new
  });

  const calculateDraftProgress = (formData) => {
    let score = 0;

    // -------- Basic Info (30%) --------
    if (formData.rfxType) score += 5;
    if (formData.productType) score += 5;
    if (formData.rfxValue) score += 5;
    if (formData.rfxbidType) score += 5;
    if (formData.rfxNoOfEvaluationType) score += 3;
    if (formData.rfxCurrency) score += 3;
    if (formData.rfxTechFocalPersonId) score += 2;
    if (formData.technicalApprovalType) score += 2;

    // -------- Header Info (20%) --------
    if (formData.rfxTitle) score += 5;
    const openDate = formData.openCloseInput?.openingDate;
    const openTime = formData.openCloseInput?.openingTime;
    const closeDate = formData.openCloseInput?.closingDate;
    const closeTime = formData.openCloseInput?.closingTime;
    if (openDate && openTime) score += 5;
    if (closeDate && closeTime) score += 5;
    if (openDate && openTime && closeDate && closeTime) score += 5;

    // -------- Description (10%) --------
    if (formData.rfxDescription) score += 10;

    // -------- Purchase Details (10%) --------
    if (formData.typeOfPurchase) score += 5;
    if (formData.otherCurrencies || formData.paymentTerms) score += 5; // adapt to your fields

    // -------- Line Items (15%) --------
    const lineItems = formData.lineItems || [];
    if (lineItems.length > 0) {
      score += 15;
      // optionally, check first line item for materialCode, quantity, etc.
    }

    // -------- Suppliers (15%) --------
    const suppliers = formData.suppliers || [];
    if (suppliers.length > 0) {
      score += 15;
    }

    return Math.min(score, 100);
  };

  const mapDraftToFormInputs = (draftData) => {
    const empty = createEmptyFormInputs();
    return {
      ...empty,
      ...draftData,
      // ensure nested objects exist
      openCloseInput: draftData.openCloseInput || empty.openCloseInput,
      lineItems: draftData.lineItems || [],
      suppliers: draftData.suppliers || [],
      termsConditions: draftData.termsConditions || [],
      editorContent: draftData.editorContent || "",
      dynamicFormDataCOMM: draftData.dynamicFormDataCOMM || [],
      dynamicFormDataTECH: draftData.dynamicFormDataTECH || [],
      chargesSelected: draftData.chargesSelected || [],
      completionPercentage: draftData.completionPercentage || 0,

      // answers: draftData.answers || {},   // <-- new
    };
  };



  const modalData = {
    title: "RFQ Creation",
    successMsg: "",
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibilityCS = () => {
    setCardVisibleCS(!isCardVisibleCS);
  };
  // const toggleCardVisibilityCT = () => {
  //   setCardVisibleCT(!isCardVisibleCT);
  // };
  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // This is for Text Editor
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const removeSupplierRow = (AssociateNumber) => {
    setSupplierData((prevPrograms) =>
      prevPrograms.filter(
        (program) => program.AssociateNumber !== AssociateNumber
      )
    );
  };

  const suppliersColumns = [
    {
      name: "Delete",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removeSupplierRow(row.AssociateNumber)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
        // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },

    {
      name: "Supplier openDate",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "EMail",
      selector: (row) => row.email,
      sortable: true,
      width: "250px",
    },
    {
      name: "initiator",
      selector: (row) => row.initiator || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "ICV Score %",
      selector: (row) => row.totalScore || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Category",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
          // onClick={() => categoryItemShowModal(row.vendorCategory)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.vendorCategory?.length || 0}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Created Date",
      selector: (row) => row.createdAt,
      sortable: true,
      width: "160px",
    },
    {
      name: "Company Code",
      cell: (row) => (
        <>
          <span> {row.companyCode} </span>
        </>
      ),
      width: "150px",
    },
  ];

  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // Get Dropdown data select
  useEffect(() => {
    console.log("Drop Down Data : ", getDropdownData)
    if (getDropdownData?.name) {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const getChangedFields = (oldData, newData) => {
    if (!oldData) return {};
    const changes = {};
    Object.keys(newData).forEach((key) => {
      if (!isEqual(oldData[key], newData[key])) {
        changes[key] = newData[key];
      }
    });
    return changes;
  };

  const getCurrentFormData = () => {
    return {
      ...formInputs,
      lineItems: getPRLineItemsData,
      suppliers: getSupplierData,
      termsConditions: termsConditionsData,
      editorContent: editorContent,
      // dynamicFormDataCOMM: dynamicFormDataCOMM,
      // dynamicFormDataTECH: dynamicFormDataTECH,
      dynamicFormDataCOMM: localFormDataCOMM,   // <-- changed
      dynamicFormDataTECH: localFormDataTECH,
      chargesSelected: getChargesSelected,
      openCloseInput: getOpenCloseInput,
      // answers: answers,   // <-- include answers
    };
  };

  // ========== DRAFT: Update draft API call ==========
  const updateDraft = async () => {
    if (!previousFormInputsRef.current || !draftDataRef.current) {
      console.warn("Skipping draft update: no baseline");
      return;
    }
    const currentData = getCurrentFormData();
    const changedData = getChangedFields(previousFormInputsRef.current, currentData);

    const newProgress = calculateDraftProgress(currentData);
    changedData.completionPercentage = newProgress;


    if (Object.keys(changedData).length === 0) {
      console.log("No changes detected, skipping draft update.");
      return;
    }

    if (Object.keys(changedData).length === 1 && changedData.completionPercentage !== undefined) {
      // Only progress changed – check if it actually changed
      const oldProgress = previousFormInputsRef.current?.completionPercentage;
      if (oldProgress === newProgress) {
        console.log("Progress unchanged, skipping.");
        return;
      }
    }

    try {
      console.log("Changed Data before Update Draft: ", changedData)
      const response = await ItemService.updateDraft(
        draftData?.documentNumber,
        userData?.userId,
        // draftData?.draftType,
        DRAFT_DOCUMENT_TYPE,
        changedData
      );
      if (response.status === 200) {
        previousFormInputsRef.current = JSON.parse(JSON.stringify(currentData));
      }
    } catch (error) {
      console.error("Update draft failed:", error);
    }
  };


  // ========== DRAFT: Load draft on mount ==========
  // useEffect(() => {
  //   const loadDraft = async () => {
  //     setIsLoadingDraft(true);
  //     try {
  //       const res = await ItemService.getDraftInitial(userData?.userId, DRAFT_DOCUMENT_TYPE);
  //       if (res.success && res.exists && res.data) {
  //         const mappedData = mapDraftToFormInputs(res.data);
  //         previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
  //         setDraftData(res.data);
  //         // Populate all separate states from mappedData
  //         setFormInputs(mappedData);
  //         setPRLineItemsData(mappedData.lineItems || []);
  //         setSupplierData(mappedData.suppliers || []);
  //         setTermsConditionsData(mappedData.termsConditions || []);
  //         setEditorContent(mappedData.editorContent || "");
  //         // dynamic forms are already in Redux, but we can also set them
  //         // they are read-only from Redux, so we ignore
  //         setChargesSelected(mappedData.chargesSelected || []);
  //         setOpenCloseInput(mappedData.openCloseInput || {
  //           openingDate: "",
  //           openingTime: "",
  //           closingDate: "",
  //           closingTime: "",
  //           totalHour: "",
  //           status: false,
  //           msg: "",
  //         });
  //       } else if (res.success && !res.exists) {
  //         const emptyData = createEmptyFormInputs();
  //         setFormInputs(emptyData);
  //         previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
  //         // Create a new draft
  //         const response = await ItemService.createDraft(userData?.userId, DRAFT_DOCUMENT_TYPE);
  //         if (response.success && response.data) {
  //           setDraftData(response.data);
  //         }
  //       }
  //     } catch (error) {
  //       console.error("getDraftInitial API Error:", error);
  //       // Initialize with empty form to avoid crash
  //       const emptyData = createEmptyFormInputs();
  //       setFormInputs(emptyData);
  //       previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
  //     } finally {
  //       setIsLoadingDraft(false);
  //     }
  //   };
  //   if (userData?.userId) {
  //     loadDraft();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userData?.userId]);

  const handleSelectDraft = async (draftNumber) => {
    try {
      const res = await ItemService.getDraftById(
        draftNumber,
        DRAFT_DOCUMENT_TYPE,
        userData?.userId
      );
      if (res?.success && res?.exists && res?.data) {
        const draft = res.data;
        const mappedData = mapDraftToFormInputs(draft);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
        setDraftData(draft);
        setFormInputs(mappedData);
        draftDataRef.current = draft;
        // Populate all separate state variables
        setPRLineItemsData(mappedData.lineItems || []);
        setSupplierData(mappedData.suppliers || []);
        setTermsConditionsData(mappedData.termsConditions || []);
        setEditorContent(mappedData.editorContent || "");
        setLocalFormDataCOMM(mappedData.dynamicFormDataCOMM || []);
        setLocalFormDataTECH(mappedData.dynamicFormDataTECH || []);
        setChargesSelected(mappedData.chargesSelected || []);
        setOpenCloseInput(mappedData.openCloseInput || {
          openingDate: "",
          openingTime: "",
          closingDate: "",
          closingTime: "",
          totalHour: "",
          status: false,
          msg: "",
        });
        // setAnswers(mappedData.answers || {});
        // Set baseline after load
        previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
      } else {
        toast.error('Failed to load draft.');
      }
    } catch (error) {
      console.error('handleSelectDraft error', error);
      toast.error('Error loading draft.');
    }
  };

  const createNewDraftAndProceed = async () => {
    try {
      const createRes = await ItemService.createDraft(userData?.userId, DRAFT_DOCUMENT_TYPE);
      if (createRes?.success && createRes?.data) {
        const emptyData = createEmptyFormInputs();
        // Populate with draft metadata (if needed)
        const draft = createRes.data;
        setDraftData(draft);
        draftDataRef.current = draft;
        setFormInputs(emptyData);
        // Reset all separate states to empty
        setPRLineItemsData([]);
        setSupplierData([]);
        setTermsConditionsData([]);
        setEditorContent("");
        setLocalFormDataCOMM([]);
        setLocalFormDataTECH([]);
        setChargesSelected([]);
        setOpenCloseInput({
          openingDate: "",
          openingTime: "",
          closingDate: "",
          closingTime: "",
          totalHour: "",
          status: false,
          msg: "",
        });
        // setAnswers({});
        previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
      } else {
        // If creation fails, use empty form without draft
        const emptyData = createEmptyFormInputs();
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
      }
    } catch (error) {
      console.error('createNewDraftAndProceed error', error);
      const emptyData = createEmptyFormInputs();
      setFormInputs(emptyData);
      previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
    }
  };

  useEffect(() => {
    console.log("Hello World... Hello Galaxy...")

    // const loadDraft = async () => {

    //   setLoadingDrafts(true);
    //   try {
    //     const res = await ItemService.getDraftInitial(userData?.userId, DRAFT_DOCUMENT_TYPE);

    //     console.log('Draft Response: ', res)

    //     if (res.success && res.exists && res.data) {

    //       const mappedData = mapDraftToFormInputs(res.data);
    //       previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
    //       setDraftData(res.data);
    //       // Populate all separate states from mappedData
    //       setFormInputs(mappedData);
    //       setPRLineItemsData(mappedData.lineItems || []);
    //       setSupplierData(mappedData.suppliers || []);
    //       setTermsConditionsData(mappedData.termsConditions || []);
    //       setEditorContent(mappedData.editorContent || "");

    //       setLocalFormDataCOMM(mappedData.dynamicFormDataCOMM || []);
    //       setLocalFormDataTECH(mappedData.dynamicFormDataTECH || []);

    //       // setAnswers(mappedData.answers || {});   // <-- add this

    //       // dynamic forms are already in Redux, but we can also set them
    //       // they are read-only from Redux, so we ignore
    //       setChargesSelected(mappedData.chargesSelected || []);
    //       setOpenCloseInput(mappedData.openCloseInput || {
    //         openingDate: "",
    //         openingTime: "",
    //         closingDate: "",
    //         closingTime: "",
    //         totalHour: "",
    //         status: false,
    //         msg: "",
    //       });

    //       // Populate local form data with answers from draft
    //       // const commWithAnswers = mappedData.dynamicFormDataCOMM.map(q => ({
    //       //   ...q,
    //       //   answer: mappedData.answers?.[q.componentId] || ''
    //       // }));
    //       // const techWithAnswers = mappedData.dynamicFormDataTECH.map(q => ({
    //       //   ...q,
    //       //   answer: mappedData.answers?.[q.componentId] || ''
    //       // }));
    //       // setLocalFormDataCOMM(commWithAnswers);
    //       // setLocalFormDataTECH(techWithAnswers);

    //     }
    //     else if (res.success && !res.exists) {
    //       const emptyData = createEmptyFormInputs();
    //       setFormInputs(emptyData);
    //       previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
    //       // Create a new draft
    //       const response = await ItemService.createDraft(userData?.userId, DRAFT_DOCUMENT_TYPE);
    //       if (response.success && response.data) {
    //         setDraftData(response.data);
    //       }

    //     }

    //   } catch (error) {
    //     console.error("getDraftInitial API Error:", error);
    //     // Initialize with empty form to avoid crash
    //     const emptyData = createEmptyFormInputs();
    //     setFormInputs(emptyData);
    //     previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
    //   } finally {
    //     setLoadingDrafts(false);
    //   }
    // };

    const loadDrafts = async () => {
      console.log("Create Manual RFQ is working....", draftIdParam)
      // Call master data (optional, but keep as in CreatePR)
      await getMasterDataFunc();

      if (draftIdParam) {
        setLoadingDrafts(true);
        try {
          await handleSelectDraft(draftIdParam);
        } catch (error) {
          console.error('loadDraftById error', error);
          toast.error('Error loading draft.');
          navigate(Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION); // adjust route as needed
        } finally {
          setLoadingDrafts(false);
        }
        return;
      }

      if (newDraftParam || !draftIdParam) {
        setLoadingDrafts(true);
        await createNewDraftAndProceed();
        setLoadingDrafts(false);
        return;
      }
    };

    if (userData?.userId) {
      loadDrafts();
    }

    // loadDrafts()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.userId, newDraftParam, draftIdParam])

  const handleAnswerChange = (componentId, value) => {
    // Check if componentId exists in COMM
    const commIndex = localFormDataCOMM.findIndex(q => q.componentId === componentId);
    if (commIndex !== -1) {
      const updated = [...localFormDataCOMM];
      updated[commIndex] = { ...updated[commIndex], answer: value };
      setLocalFormDataCOMM(updated);
      return;
    }
    const techIndex = localFormDataTECH.findIndex(q => q.componentId === componentId);
    if (techIndex !== -1) {
      const updated = [...localFormDataTECH];
      updated[techIndex] = { ...updated[techIndex], answer: value };
      setLocalFormDataTECH(updated);
      return;
    }
  };





  /* submit button */
  const handleCreateManualRFQ = async () => {
    let requiredFields = [];

    if (formInputs.rfxValue === "") {
      requiredFields.push("* Please enter the Estimated RFQ Value.");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    if (getSupplierData.length === 0) {
      requiredFields.push("* Add atleast one supplier.");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    // if (localFormDataCOMM.length === 0) {
    //   requiredFields.push("*Add atleast one Form: COMM- Spares.");
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    // if (localFormDataTECH.length === 0) {
    //   requiredFields.push("* Add atleast one Form : TECH - Spares.");
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }
    if (getOpenCloseInput.status === false) {
      if (getOpenCloseInput.msg === "") {
        requiredFields.push("* Please update Opening and Closing Date, Time");
      } else {
        requiredFields.push(getOpenCloseInput.msg);
      }

      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    formInputs.items =
      rfqCreation === "PR" ? getLineItemData : getPRLineItemsData;
    formInputs.supplierList = getSupplierData;
    formInputs.termsConditions = termsConditionsData;
    formInputs.instructions = editorContent;
    formInputs.formCOMM = localFormDataCOMM;
    formInputs.formTECH = localFormDataTECH;

    // open and close date
    formInputs.openingDateTime =
      getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
    formInputs.closingDateTime =
      getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
    formInputs.totalHour = getOpenCloseInput.totalHour;

    formInputs.openingDate = getOpenCloseInput.openingDate;
    formInputs.openingTime = getOpenCloseInput.openingTime;
    formInputs.closingDate = getOpenCloseInput.closingDate;
    formInputs.closingTime = getOpenCloseInput.closingTime;

    // Other Charges
    formInputs.othersCharge = getChargesSelected;
    formInputs.qtnSubTotalLineItem = subTotalValue;
    formInputs.qtnSubTotalOtherCharges = getOtherChargesValue;
    formInputs.qtnTotal = (subTotalValue || 0) + (getOtherChargesValue || 0);

    // console.log(">> handleCreateManualRFQ", formInputs);

    // DRAFT: Add draft metadata to payload
    formInputs.draftData = {
      draftUserId: userData?.userId,
      draftDocumentNumber: draftData?.documentNumber,
      draftType: draftData?.draftType,
    };

    formInputs.completionPercentage = calculateDraftProgress(formInputs);

    let obj = {
      data: formInputs,
    };
    setDisabled(true);
    await ItemService.addRfx(obj).then((item) => {
      // console.log(">> item! ", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        onSuccessfullyRegistered();
        dispatch(getRfqQuotation({}));
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setDisabled(false);
  };



  /* suppplierModalShow */
  const [getSupplierModal, setSupplierModal] = useState(false);
  const suppplierModalShow = () => {
    setSupplierModal(true);
  };
  const supplerMoadHide = () => {
    setSupplierModal(false);
  };
  /* selectedSupplierIds */
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [getSupplierData, setSupplierData] = useState([]);
  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };

  const handlePassDataToParent = (data) => {
    // console.log("Data received from child:", data);
    // You can now use this data in the parent component

    setSupplierData((prevData) => {
      // Combine previous data and filter out duplicates based on id
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber
            )
        ),
      ];

      return updatedData;
    });
  };



  const [termsConditionsData, setTermsConditionsData] = useState([
    {
      id: 1,
      name: "Terms and Conditions",
      status: true,
      disabled: true,
    },
    {
      id: 2,
      name: "Code of Conduct",
      status: false,
    },
    // {
    //   id: 3,
    //   name: "HSE Requirements",
    //   status: false,
    // },
    // {
    //   id: 4,
    //   name: "Engineering Standards",
    //   status: false,
    // },
    {
      id: 3,
      name: "Packaging Requirement",
      status: false,
    },
    {
      id: 4,
      name: "Others",
      status: false,
    },
    // {
    //   id: 7,
    //   name: "Trucking H&S Requirements",
    //   status: false,
    // },
  ]);

  const handleTermsConditionCheckBox = (id) => {
    // Update the status of the item based on its id
    const updatedData = termsConditionsData.map((item) => {
      if (item.id === id) {
        return { ...item, status: !item.status };
      }
      return item;
    });
    // Update the state with the modified data
    setTermsConditionsData(updatedData);
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "VAT Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let PRLineItemInitialData = [
    {
      local_id: 1,
      rfxNr: 1,
      purchaseReqDocumentNr: "ManualPR",
      itemTextData: [],
      statusItem: "In Release",
      // currency: getCurrencyDropdown.name || "Rupee",
      // currencyCode: getCurrencyDropdown.code || "INR",
      currency: "Rupee",
      currencyCode: "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const [getPRLineItemsData, setPRLineItemsData] = useState(
    PRLineItemInitialData
  );

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPRLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                ...row,
                [name]: value,
                netValue:
                  name === "purchaseQuantity"
                    ? row.orderPriceUnit * value
                    : row.purchaseQuantity * value,
                taxAmount:
                  (Number(row.taxCode) / 100) *
                  (name === "purchaseQuantity"
                    ? row.orderPriceUnit * value
                    : row.purchaseQuantity * value),
              }
              : row;
          })
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPRLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                ...row,
                [name]: value,
                taxAmount:
                  name === "taxCode"
                    ? (Number(value) / 100) *
                    (Number(row.purchaseQuantity || 0) *
                      Number(row.orderPriceUnit || 0))
                    : 0,
              }
              : row
          )
        );
      }
    } else {
      setPRLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row
        )
      );
    }
    // getTotalCount()
  };

  // Add or Remove Line Item
  const addPOItemRow = () => {
    setPRLineItemsData((prevRows) => {
      PRLineItemInitialData[0].local_id = prevRows.length + 1;
      PRLineItemInitialData[0].rfxNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...PRLineItemInitialData];
    });
  };
  const removePOItemRow = (local_id) => {
    setPRLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };

  //Load Master Data
  const getMasterDataFunc = async () => {
    let obj1 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj2 = {
      codeType: "RFxType",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setRFxType(item?.data);
      } else {
        setRFxType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj3 = {
      codeType: "RFxProductType",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setRFxProductType(item?.data);
      } else {
        setRFxProductType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj4 = {
      codeType: "CompanyAddress",
    };
    await ItemService.getMasterData(obj4).then((item) => {
      if (item?.status === 200) {
        setCompanyAddress(item?.data);
      } else {
        setCompanyAddress([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj5 = {
      codeType: "BillingAddress",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      if (item?.status === 200) {
        setBillingAddress(item?.data);
      } else {
        setBillingAddress([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "DeliveryAddress",
    };
    await ItemService.getMasterData(obj6).then((item) => {
      if (item?.status === 200) {
        setDeliveryAddress(item?.data);
      } else {
        setDeliveryAddress([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj7 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj7).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj8 = {
      codeType: "INCOTerms",
    };
    await ItemService.getMasterData(obj8).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj9 = {
      codeType: "RfxPurchaseType",
    };
    await ItemService.getMasterData(obj9).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setRfxPurchaseType(item?.data);
      } else {
        setRfxPurchaseType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj10 = {
      codeType: "RfxBidType",
    };
    await ItemService.getMasterData(obj10).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setRfxBidType(item?.data);
      } else {
        setRfxBidType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj11 = {
      codeType: "TechnicalApprovalType",
    };
    await ItemService.getMasterData(obj11).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalApprovalType(item?.data);
      } else {
        setTechnicalApprovalType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj12 = {
      codeType: "RfxNoOfEvaluationType",
    };
    await ItemService.getMasterData(obj12).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setRfxNoOfEvaluationType(item?.data);
      } else {
        setRfxNoOfEvaluationType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj13 = {
      codeType: "Plant",
    };
    await ItemService.getMasterData(obj13).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setPlant(item?.data);
      } else {
        setPlant([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj14 = {
      codeType: "OtherChargesID",
    };
    await ItemService.getMasterData(obj14).then((item) => {
      if (item?.status === 200) {
        setChargesSelection(item?.data);
      } else {
        setChargesSelection([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  const loadLineItem = async () => {
    let obj6 = {
      purchaseReqDocumentNr: approvedSelectedRows,
    };
    await ItemService.getPRLineItems(obj6).then((item) => {
      if (item?.status === 200) {
        const updatedItemData = item?.data.map((obj, index) => ({
          ...obj,
          rfxItemNr: index + 1,
          local_id: index + 1,
          purchaseReqDocumentNr: "ManualPR",
        }));
        setLineItemData(updatedItemData);
      } else {
        setLineItemData([]);
        console.log(">> Error: Loading Line Items");
      }
    });
  };
  const loadTechUser = async () => {
    let obj = {
      roleId: "TECHNICAL",
    };
    await ItemService.getTechnicalUser(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalUserList(item?.data);
      } else {
        setTechnicalUserList([]);
        console.log(">> Error: Loading loadTechUser");
      }
    });
  };

  useEffect(() => {
    const isDraftMode = draftIdParam || newDraftParam;
    if (isDraftMode || rfqCreation !== "") {
      getMasterDataFunc();
      loadLineItem();
      loadTechUser();

      if (rfqCreation === "PR") {
        localStorage.setItem("menu", "Sourcing");
        localStorage.setItem("submenu", "Purchase Requisition");
      } else if (rfqCreation !== "") {
        localStorage.setItem("menu", "Sourcing");
        localStorage.setItem("submenu", "Request for Quotation");
      }
    } else {
      window.history.back();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // useEffect(() => {
  //   // If we are loading a draft (via location state), do not redirect
  //   if (draftIdParam || newDraftParam) {
  //     return;
  //   }

  //   // Not in draft mode – check if we have a valid rfqCreation context
  //   if (rfqCreation !== "") {
  //     // Set menu/submenu for the page
  //     if (rfqCreation === "PR") {
  //       localStorage.setItem("menu", "Sourcing");
  //       localStorage.setItem("submenu", "Purchase Requisition");
  //     } else {
  //       localStorage.setItem("menu", "Sourcing");
  //       localStorage.setItem("submenu", "Request for Quotation");
  //     }
  //   } else {
  //     // No valid context – go back
  //     window.history.back();
  //   }
  // }, [draftIdParam, newDraftParam, rfqCreation]);

  const createDynamicformModelCOMM = () => {
    let obj = {
      formType: "COMM",
    };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };
  const createDynamicformModelTECH = () => {
    let obj = {
      formType: "TECH",
    };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };

  const hideModalStatus = () => {
    setCreateDynamicformModelShow(false);
  };

  // Render Questions
  // const RenderInputField = ({ questionData }) => {
  //   const { componentId, mandatory, question, answerDefinition, serialNo } =
  //     questionData;

  //   const handleChange = (value) => {
  //     setAnswers(prev => ({
  //       ...prev,
  //       [componentId]: value,
  //     }));
  //   };

  //   const currentValue = answers[componentId] ?? '';

  //   switch (answerDefinition?.type) {
  //     case "textarea":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
  //           <TextAreaField
  //             label={serialNo + ". " + question?.label}
  //             id={componentId}
  //             name={componentId}
  //             className="inputBox"
  //             placeholder=""
  //             // value={}
  //             value={currentValue}
  //             // onChange={handleInputChange}
  //             onChange={(e) => handleChange(e.target.value)}
  //             required={mandatory}
  //           />
  //         </Col>
  //       );
  //     case "select":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <ComboboxField3
  //             label={serialNo + ". " + question?.label}
  //             placeholder=""
  //             data={answerDefinition?.options}
  //             id={componentId}
  //             iconClassName="dropdownIcon"
  //             name={componentId}
  //             code={componentId}
  //             required={mandatory}
  //             // setValue={formData.type || ""}
  //              value={currentValue}
  //               onChange={(selected) => handleChange(selected?.value ?? selected)}
  //             // getvalue={setDropdownData}
  //           />
  //         </Col>
  //       );
  //     case "radio":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
  //             {serialNo + ". " + question?.label} {mandatory && "*"}
  //           </label>

  //           {answerDefinition?.options.map((option, index) => {
  //             return (
  //               <div key={index} className="block">
  //                 <input
  //                   type="radio"
  //                   className="form-check-input fs-5 ml-3"
  //                   id={`${componentId}-${index}`}
  //                   name={componentId}
  //                   // value={option?.value}
  //                   required={mandatory}
  //                 />
  //                 <span className="ml-3">{option?.value} </span>
  //               </div>
  //             );
  //           })}
  //         </Col>
  //       );
  //     case "checkbox":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
  //             {serialNo + ". " + question?.label} {mandatory && "*"}
  //           </label>

  //           {answerDefinition?.options.map((option, index) => {
  //             return (
  //               <div key={index} className="block">
  //                 <input
  //                   type="checkbox"
  //                   className="form-check-input fs-5 ml-3"
  //                   id={`${componentId}-${index}`}
  //                   name={componentId}
  //                   // value={option?.value}
  //                   required={mandatory}
  //                 />
  //                 <span className="ml-3">{option?.value} </span>
  //               </div>
  //             );
  //           })}
  //         </Col>
  //       );
  //     case "text":
  //       return (
  //         <Col
  //           xs={12}
  //           md={6}
  //           lg={6}
  //           className="commTopButtonRightLeftPadding block"
  //         >
  //           <InputField
  //             label={serialNo + ". " + question?.label}
  //             type="text"
  //             className="inputBox"
  //             id={componentId}
  //             name={componentId}
  //             placeholder=""
  //             // value={option.value}
  //             // onChange={(e) =>
  //             //   handleOptionChange(index, e.target.value)
  //             // }
  //             required={mandatory}
  //           />
  //         </Col>
  //       );
  //     case "number":
  //       return (
  //         <Col
  //           xs={12}
  //           md={6}
  //           lg={6}
  //           className="commTopButtonRightLeftPadding block"
  //         >
  //           <InputField
  //             label={serialNo + ". " + question?.label}
  //             type="number"
  //             className="inputBox"
  //             id={componentId}
  //             name={componentId}
  //             placeholder=""
  //             // value={option.value}
  //             // onChange={(e) =>
  //             //   handleOptionChange(index, e.target.value)
  //             // }
  //             required={mandatory}
  //           />
  //         </Col>
  //       );
  //     default:
  //       return "";
  //   }
  // };

  // const RenderInputField = ({ questionData }) => {
  //   const { componentId, mandatory, question, answerDefinition, serialNo } = questionData;

  //   const handleChange = (value) => {
  //     setAnswers(prev => ({
  //       ...prev,
  //       [componentId]: value,
  //     }));
  //   };

  //   const currentValue = answers[componentId] ?? '';

  //   switch (answerDefinition?.type) {
  //     case "textarea":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
  //           <TextAreaField
  //             label={serialNo + ". " + question?.label}
  //             id={componentId}
  //             name={componentId}
  //             className="inputBox"
  //             placeholder=""
  //             value={currentValue}
  //             onChange={(e) => handleChange(e.target.value)}
  //             required={mandatory}
  //           />
  //         </Col>
  //       );

  //     case "select":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <ComboboxField3
  //             label={serialNo + ". " + question?.label}
  //             placeholder=""
  //             data={answerDefinition?.options}
  //             id={componentId}
  //             iconClassName="dropdownIcon"
  //             name={componentId}
  //             // code={componentId}
  //             code="value"
  //             description="name"
  //             required={mandatory}
  //             // value={currentValue}
  //             // onChange={(selected) => handleChange(selected?.value ?? selected)}
  //             setValue={currentValue}   // <-- pass the saved answer string
  //             getvalue={(selected) => handleChange(selected?.value ?? selected)}
  //           />
  //         </Col>
  //       );

  //     case "radio":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
  //             {serialNo + ". " + question?.label} {mandatory && "*"}
  //           </label>
  //           {answerDefinition?.options.map((option, index) => (
  //             <div key={index} className="block">
  //               <input
  //                 type="radio"
  //                 className="form-check-input fs-5 ml-3"
  //                 id={`${componentId}-${index}`}
  //                 name={componentId}
  //                 value={option?.value}
  //                 checked={currentValue === option?.value}
  //                 onChange={() => handleChange(option?.value)}
  //                 required={mandatory}
  //               />
  //               <span className="ml-3">{option?.value}</span>
  //             </div>
  //           ))}
  //         </Col>
  //       );

  //     case "checkbox":
  //       // For checkboxes we store a comma‑separated string (or an array – adapt as needed)
  //       const toggleCheckbox = (optionValue) => {
  //         const currentArray = currentValue ? currentValue.split(',') : [];
  //         const isChecked = currentArray.includes(optionValue);
  //         let newArray;
  //         if (isChecked) {
  //           newArray = currentArray.filter(v => v !== optionValue);
  //         } else {
  //           newArray = [...currentArray, optionValue];
  //         }
  //         handleChange(newArray.join(','));
  //       };

  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
  //           <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
  //             {serialNo + ". " + question?.label} {mandatory && "*"}
  //           </label>
  //           {answerDefinition?.options.map((option, index) => {
  //             const isChecked = currentValue ? currentValue.split(',').includes(option?.value) : false;
  //             return (
  //               <div key={index} className="block">
  //                 <input
  //                   type="checkbox"
  //                   className="form-check-input fs-5 ml-3"
  //                   id={`${componentId}-${index}`}
  //                   name={componentId}
  //                   value={option?.value}
  //                   checked={isChecked}
  //                   onChange={() => toggleCheckbox(option?.value)}
  //                   required={mandatory}
  //                 />
  //                 <span className="ml-3">{option?.value}</span>
  //               </div>
  //             );
  //           })}
  //         </Col>
  //       );

  //     case "text":
  //     case "number":
  //       return (
  //         <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding block">
  //           <InputField
  //             label={serialNo + ". " + question?.label}
  //             type={answerDefinition?.type === 'number' ? 'number' : 'text'}
  //             className="inputBox"
  //             id={componentId}
  //             name={componentId}
  //             placeholder=""
  //             value={currentValue}
  //             onChange={(e) => handleChange(e.target.value)}
  //             required={mandatory}
  //           />
  //         </Col>
  //       );

  //     default:
  //       return null;
  //   }
  // };

  const RenderInputField = ({ questionData }) => {
    const { componentId, mandatory, question, answerDefinition, serialNo } = questionData;

    // const handleChange = (value) => {
    //   setAnswers(prev => ({
    //     ...prev,
    //     [componentId]: value,
    //   }));
    // };

    // const currentValue = answers[componentId] ?? '';

    const currentValue = questionData.answer ?? '';   // <-- read answer from the question itself

    switch (answerDefinition?.type) {
      case "textarea":
        return (
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <TextAreaField
              label={serialNo + ". " + question?.label}
              id={componentId}
              name={componentId}
              className="inputBox"
              placeholder=""
              value={currentValue}
              // onChange={(e) => handleChange(e.target.value)}
              onChange={(e) => handleAnswerChange(componentId, e.target.value)}
              required={mandatory}
            />
          </Col>
        );

      // case "select":
      //   return (
      //     <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
      //       <ComboboxField3
      //         key={`${componentId}-${currentValue}`}
      //         label={serialNo + ". " + question?.label}
      //         placeholder=""
      //         data={answerDefinition?.options}
      //         id={componentId}
      //         iconClassName="dropdownIcon"
      //         name={componentId}
      //         code="value"              // important
      //         description="name"        // important
      //         required={mandatory}
      //         setValue={currentValue}   // important
      //         getvalue={(selected) => handleChange(selected?.value ?? selected)}
      //       />
      //     </Col>
      //   );

      case "select":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <ComboboxField4
              label={serialNo + ". " + question?.label}
              placeholder=""
              data={answerDefinition?.options}
              id={componentId}
              iconClassName="dropdownIcon"
              name={componentId}
              required={mandatory}
              value={currentValue}                 // <-- controlled value
              // onChange={(newValue) => handleChange(newValue)} // <-- updates answers
              onChange={(newValue) => handleAnswerChange(componentId, newValue)}
            // Remove: code, description, setValue, getvalue

            />
          </Col>
        );

      case "radio":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>
            {answerDefinition?.options.map((option, index) => (
              <div key={index} className="block">
                <input
                  type="radio"
                  className="form-check-input fs-5 ml-3"
                  id={`${componentId}-${index}`}
                  name={componentId}
                  value={option?.value}
                  checked={currentValue === option?.value}
                  // onChange={() => handleChange(option?.value)}
                  onChange={() => handleAnswerChange(componentId, option?.value)}
                  required={mandatory}
                />
                <span className="ml-3">{option?.value}</span>
              </div>
            ))}
          </Col>
        );

      case "checkbox":
        const toggleCheckbox = (optionValue) => {
          const currentArray = currentValue ? currentValue.split(',') : [];
          const isChecked = currentArray.includes(optionValue);
          let newArray;
          if (isChecked) {
            newArray = currentArray.filter(v => v !== optionValue);
          } else {
            newArray = [...currentArray, optionValue];
          }
          // handleChange(newArray.join(','));
          handleAnswerChange(componentId, newArray.join(','));
        };

        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
            <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
              {serialNo + ". " + question?.label} {mandatory && "*"}
            </label>
            {answerDefinition?.options.map((option, index) => {
              const isChecked = currentValue ? currentValue.split(',').includes(option?.value) : false;
              return (
                <div key={index} className="block">
                  <input
                    type="checkbox"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    value={option?.value}
                    checked={isChecked}
                    onChange={() => toggleCheckbox(option?.value)}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value}</span>
                </div>
              );
            })}
          </Col>
        );

      case "text":
      case "number":
        return (
          <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding block">
            <InputField
              label={serialNo + ". " + question?.label}
              type={answerDefinition?.type === 'number' ? 'number' : 'text'}
              className="inputBox"
              id={componentId}
              name={componentId}
              placeholder=""
              value={currentValue}
              // onChange={(e) => handleChange(e.target.value)}
              onChange={(e) => handleAnswerChange(componentId, e.target.value)}
              required={mandatory}
            />
          </Col>
        );

      default:
        return null;
    }
  };

  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((getOpenCloseInput) => ({
      ...getOpenCloseInput,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);
      // console.log(">> res", res);
      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";

      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        } else {
          toast.error(res.msg, {
            duration: 4000,
            position: "top-right",
          });
        }
      }
    }
  }, [getOpenCloseInput]);

  // Set Default Form value
  // useEffect(() => {
  //   if (config) {
  //     dispatch(addDynamicFormDataCOMM(config?.RFX?.formCOMM));
  //     dispatch(addDynamicFormDataTECH(config?.RFX?.formTECH));
  //   } else {
  //     toast.error("Error while getting the default form value !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [config]);


  useEffect(() => {
    if (config) {
      const comm = config?.RFX?.formCOMM || [];
      const tech = config?.RFX?.formTECH || [];
      dispatch(addDynamicFormDataCOMM(comm));
      dispatch(addDynamicFormDataTECH(tech));
      // Add answer fields (initially empty) to local copies
      setLocalFormDataCOMM(comm.map(q => ({ ...q, answer: '' })));
      setLocalFormDataTECH(tech.map(q => ({ ...q, answer: '' })));
    } else {
      toast.error("Error while getting the default form value !!", {
        duration: 4000,
        position: "top-right",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };


  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  ///

  // Calculate total from other charges
  useEffect(() => {
    const total = getChargesSelected.reduce(
      (sum, item) => sum + (Number(item?.amount) || 0),
      0
    );
    setOtherChargesValue(total);
  }, [getChargesSelected]);

  // Calculate subtotal from line items
  useEffect(() => {
    const items = rfqCreation === "PR" ? getLineItemData : getPRLineItemsData;
    const total = items.reduce(
      (sum, item) => sum + (Number(item?.netValue) || 0),
      0
    );
    setSubTotalValue(total);
  }, [getLineItemData, getPRLineItemsData, rfqCreation]);

  // const HeaderTextColumns = [
  //   {
  //     name: "Code",
  //     cell: (row) => (
  //       <>
  //         <span>{row.documentId}</span>
  //       </>
  //     ),
  //     width: "10rem",
  //   },
  //   {
  //     name: "Description",
  //     cell: (row) => (
  //       <>
  //         <span>{row.documentText}</span>
  //       </>
  //     ),
  //     width: "15rem",
  //   },
  //   {
  //     name: "Amount",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           type="number"
  //           className="inputBox mt-1"
  //           min="0"
  //           value={row.amount || 0}
  //           onChange={(e) =>
  //             handleChargesAmountChange(row.id, e.target.value)
  //           }
  //         />
  //       </>
  //     ),
  //     width: "15rem",
  //   },
  // ];
  /* Toggle charge selection from Charges Selection checkboxes */
  const handleChargeToggle = (charge) => {
    setChargesSelected((prev) => {
      const exists = prev.find((item) => item.id === charge.id);
      if (exists) {
        return prev.filter((item) => item.id !== charge.id);
      } else {
        return [
          ...prev,
          {
            ...charge,
            documentId: charge.code,
            documentText: charge.name,
            amount: 0,
          },
        ];
      }
    });
  };
  /* Handle amount change in Other Charges table */
  // const handleChargesAmountChange = (id, value) => {
  //   if (value === "" || Number(value) > 0) {
  //     setChargesSelected((prev) =>
  //       prev.map((item) =>
  //         item.id === id ? { ...item, amount: value } : item
  //       )
  //     );
  //   }
  // };

  // ========== DRAFT: Autosave effect ==========
  useEffect(() => {
    if (isFirstAutoSave.current) {
      isFirstAutoSave.current = false;
      // Store initial baseline (already set after draft load)
      previousFormInputsRef.current = JSON.parse(JSON.stringify(getCurrentFormData()));
      return;
    }

    if (loadingDrafts || !draftDataRef.current || !previousFormInputsRef.current) return;

    const currentData = getCurrentFormData();
    const hasDataChanged = JSON.stringify(previousFormInputsRef.current) !== JSON.stringify(currentData);
    if (!hasDataChanged) return;

    const timer = setTimeout(async () => {
      try {
        await updateDraft();
        // baseline is updated inside updateDraft on success
      } catch (error) {
        console.error(error);
      }
    }, 2000);

    return () => clearTimeout(timer);
    // Dependencies: all states that affect the form data
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formInputs,
    getPRLineItemsData,
    getSupplierData,
    termsConditionsData,
    editorContent,
    // dynamicFormDataCOMM,
    // dynamicFormDataTECH,
    localFormDataCOMM,    // <-- changed
    localFormDataTECH,
    getChargesSelected,
    getOpenCloseInput,
    loadingDrafts,
    // answers
  ]);

  // useEffect(() => {
  //   // Collect all componentIds from both COMM and TECH forms
  //   const allComponentIds = [
  //     ...dynamicFormDataCOMM.map(q => q.componentId),
  //     ...dynamicFormDataTECH.map(q => q.componentId),
  //   ];
  //   // setAnswers(prev => {
  //   //   const newAnswers = { ...prev };
  //   //   Object.keys(newAnswers).forEach(key => {
  //   //     if (!allComponentIds.includes(key)) {
  //   //       delete newAnswers[key];
  //   //     }
  //   //   });
  //   //   return newAnswers;
  //   // });
  // }, [dynamicFormDataCOMM, dynamicFormDataTECH]);

  // Also keep draftDataRef in sync
  useEffect(() => {
    draftDataRef.current = draftData;
  }, [draftData]);

  // ========== Render ==========

  // Wizard tab state + navigation helpers. Current index is derived from the
  // active tab so Previous / Next can be shown conditionally below the tabs.
  const [activeTab, setActiveTab] = useState("rfq-title");
  const currentTabIndex = tabList.findIndex((tab) => tab.id === activeTab);
  const isLastTab = currentTabIndex === tabList.length - 1;
  const goToPreviousTab = () => {
    if (currentTabIndex > 0) setActiveTab(tabList[currentTabIndex - 1].id);
  };
  const goToNextTab = () => {
    if (currentTabIndex < tabList.length - 1)
      setActiveTab(tabList[currentTabIndex + 1].id);
  };

  // if (loadingDrafts) {
  //   return <div>Loading draft...</div>;
  // }

  if (loadingDrafts) {
    return (
      <main className="dashboard main" id="main">
        <Layout />

        <Loader isLoading={loadingDrafts} className={"text-center"} />
      </main>
    );
  }

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create {rfqCreation} RFQ</h2>
            <p className="subText">Fill RFQ Details</p>
            <hr />

            <div className="card">
              <div className="card-body">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {tabList.map((tab) => {
                    const isActive = activeTab === tab.id;
                    return (
                      <li className="nav-item" role="presentation" key={tab.id}>
                        <button
                          className={`nav-link ${isActive ? "active" : ""}`}
                          id={`${tab.id}-tab`}
                          type="button"
                          role="tab"
                          aria-controls={tab.id}
                          aria-selected={isActive ? "true" : "false"}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    );
                  })}
                </ul>
                <div className="tab-content pt-2" id="myTabContent">
                  <div
                    className={`tab-pane fade ${
                      activeTab === "rfq-title" ? "show active" : ""
                    }`}
                    id="rfq-title"
                    role="tabpanel"
                    aria-labelledby="rfq-title-tab"
                  >
            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RT</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">RFQ Type</span>
                      <span className="subHeaderTitle">Basic Information</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="RFQ Type"
                          placeholder=""
                          data={getRFxType}
                          id="rfxType"
                          iconClassName="dropdownIcon"
                          name="rfxType"
                          code="rfxTypeCode"
                          description="rfxTypeDesc"
                          setValue={formInputs.rfxType || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Product Type"
                          placeholder=""
                          data={getRFxProductType}
                          id="productType"
                          iconClassName="dropdownIcon"
                          name="productType"
                          code="productTypeCode"
                          description="productTypeDesc"
                          setValue={formInputs.productType || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Estimated RFQ Value *"
                          id="rfxValue"
                          name="rfxValue"
                          placeholder=""
                          // type="checkbox"
                          value={formInputs.rfxValue || ""}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Bid Type"
                          placeholder=""
                          data={getRfxBidType}
                          id="rfxbidType"
                          iconClassName="dropdownIcon"
                          name="rfxbidType"
                          code="rfxbidTypeCode"
                          description="rfxbidTypeDesc"
                          setValue={formInputs.rfxbidType || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Number Of Evaluation"
                          placeholder=""
                          data={getRfxNoOfEvaluationType}
                          id="rfxNoOfEvaluationType"
                          iconClassName="dropdownIcon"
                          name="rfxNoOfEvaluationType"
                          code="rfxNoOfEvaluationTypeCode"
                          description="rfxNoOfEvaluationTypeDesc"
                          setValue={formInputs.rfxNoOfEvaluationType || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Currency"
                          placeholder=""
                          data={getcurrency}
                          id="rfxCurrency"
                          iconClassName="dropdownIcon"
                          name="rfxCurrency"
                          code="rfxCurrencyCode"
                          description="rfxCurrencyDesc"
                          setValue={formInputs.rfxCurrency || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Tech Focal Point *"
                          placeholder=""
                          data={getTechnicalUserList}
                          id="rfxTechFocalPersonId"
                          iconClassName="dropdownIcon"
                          name="rfxTechFocalPersonId"
                          code="rfxTechFocalPersonIdCode"
                          description="rfxTechFocalPersonIdDesc"
                          setValue={formInputs.rfxTechFocalPersonId || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Technical Approval Type"
                          placeholder=""
                          data={getTechnicalApprovalType}
                          id="technicalApprovalType"
                          iconClassName="dropdownIcon"
                          name="technicalApprovalType"
                          code="technicalApprovalTypeCode"
                          description="technicalApprovalTypeDesc"
                          setValue={formInputs.technicalApprovalType || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* 02 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RH</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">RFQ Header</span>
                      <span className="subHeaderTitle">Header Description</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Responsible"
                          name="buyerResponsible"
                          placeholder=""
                          value={formInputs.buyerResponsible || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Create / Initiator"
                          name="initiator"
                          placeholder=""
                          value={formInputs.initiator || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Plant"
                          placeholder=""
                          data={getPlant}
                          id="plant"
                          iconClassName="dropdownIcon"
                          name="plant"
                          code="plantCode"
                          description="plantDesc"
                          setValue={formInputs.plant || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Company Address"
                          placeholder=""
                          data={getCompanyAddress}
                          id="companyAddress"
                          iconClassName="dropdownIcon"
                          name="companyAddress"
                          code="companyAddressCode"
                          description="companyAddressDesc"
                          setValue={formInputs.companyAddress || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ Version"
                          name="rfxVersion"
                          id="rfxVersion"
                          placeholder=""
                          value={formInputs.rfxVersion || ""}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Email"
                          name="buyerEmail"
                          id="buyerEmail"
                          placeholder=""
                          value={formInputs.buyerEmail || ""}
                          // onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Billing Address"
                          placeholder=""
                          data={getBillingAddress}
                          id="billingAddress"
                          iconClassName="dropdownIcon"
                          name="billingAddress"
                          code="billingAddressCode"
                          description="billingAddressDesc"
                          setValue={formInputs.billingAddress || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created On"
                          name="createdOn"
                          id="createdOn"
                          placeholder=""
                          value={formInputs.createdOn || ""}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Buyer Contact"
                          name="buyerConact"
                          id="buyerConact"
                          placeholder=""
                          value={formInputs.buyerConact || ""}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Delivery Address"
                          placeholder=""
                          data={getDeliveryAddress}
                          id="deliveryAddressCodeDesc"
                          iconClassName="dropdownIcon"
                          name="deliveryAddressCodeDesc"
                          setValue={formInputs.deliveryAddressCodeDesc || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="RFQ Category"
                          name="rfxCategory"
                          id="rfxCategory"
                          placeholder=""
                          value={formInputs.rfxCategoryType}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "configuration" ? "show active" : ""
                    }`}
                    id="configuration"
                    role="tabpanel"
                    aria-labelledby="configuration-tab"
                  >
            {/* header info 03*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Header Info</span>
                      <span className="subHeaderTitle">Header Information</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Title"
                          name="rfxTitle"
                          id="rfxTitle"
                          placeholder=""
                          value={formInputs.rfxTitle || ""}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Description"
                          name="rfxDescription"
                          id="rfxDescription"
                          placeholder=""
                          value={formInputs.rfxDescription || ""}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Type of Purchase"
                          placeholder=""
                          data={getRfxPurchaseType}
                          id="typeOfPurchase"
                          iconClassName="dropdownIcon"
                          name="typeOfPurchase"
                          setValue={formInputs.typeOfPurchase || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="Other Currencies"
                          placeholder="Please select the Other Currencies"
                          data={getcurrency}
                          id="othercurrencies"
                          iconClassName="dropdownIcon"
                          name="othercurrencies"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Payment Term"
                          placeholder=""
                          data={getpaymentTerm}
                          id="otherCurrencies"
                          iconClassName="dropdownIcon"
                          name="otherCurrencies"
                          setValue={formInputs.otherCurrencies || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <MultiselectField
                          label="INCO Terms"
                          placeholder="Please select the INCO Terms"
                          data={getINCOTerms}
                          id="INCOTerms"
                          iconClassName="dropdownIcon"
                          name="INCOTerms"
                          getvalue={setDropdownData}
                          className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="INCO Terms Location"
                          name="incoTermsLocation"
                          id="incoTermsLocation"
                          placeholder=""
                          // setValue={formInputs.incoTermsLocation || ""}
                          value={formInputs.incoTermsLocation || ""}

                          onChange={onInputChange}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Procurement Strategy"
                          placeholder=""
                          data={dropdownOption}
                          id="procurementStrategies"
                          iconClassName="dropdownIcon"
                          name="procurementStrategies"
                          setValue={formInputs.procurementStrategies || ""}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Milestone Payments"
                          placeholder=""
                          data={dropdownOption}
                          id="milestonepayments"
                          iconClassName="dropdownIcon"
                          name="milestonepayments"
                          setValue={formInputs.milestonepayments || ""}
                          getvalue={setDropdownData}
                          // className="dropdownOption"
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        
                        <input type="file" id="myfile" name="myfile" /> 
                        <InputField
                          className="inputBox"
                          label="Instructions Attachment"
                          name=""
                          // placeholder=""
                          // value={PriceSheduleModuledata.UnitPrice || ""}
                          type="file"
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField3
                          label="Reminder Enabled"
                          placeholder=""
                          data={reminderDropDown}
                          id="reminderEnabled"
                          iconClassName="dropdownIcon"
                          name="reminderEnabled"
                          code="reminderEnabledCode"
                          description="reminderEnabledDesc"
                          setValue={formInputs.reminderEnabled || ""}
                          getvalue={setDropdownData}
                        // className="dropdownOption"
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="instructionsAttachment"
                          name="instructionsAttachment"
                          label="Instructions Attachment"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.instructionsAttachment || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.instructionsAttachment && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.instructionsAttachment)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Instructions 10*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible10
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility10}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">RE</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Instructions</span>
                      <span className="subHeaderTitle">
                        Instructions Section
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="p-4">
                      <Col xs={12} md={12} lg={12}>
                        <RichTextEditor
                          value={editorContent}
                          onChange={handleEditorChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents 05 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible5
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Documents</span>
                      <span className="subHeaderTitle">Documents Form</span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <h5 className="card-title"> Terms & Conditions</h5>
                      <Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={8}
                          className="commTopButtonRightLeftPadding"
                        >
                          {termsConditionsData.map((item, i) => (
                            <div className="form-check" key={item.id}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`gridCheck${item.id}`}
                                checked={item.status}
                                onChange={() =>
                                  handleTermsConditionCheckBox(item.id)
                                }
                                disabled={item?.disabled}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`gridCheck${item.id}`}
                              >
                                {item.name}
                              </label>
                            </div>
                          ))}
                        </Col>
                        <Col xs={12} md={12} lg={3}>
                          <ComboboxField3
                            label="Acceptance To Terms & Conditions"
                            placeholder=""
                            data={dropdownOption}
                            id="incoTermsLocation"
                            iconClassName="dropdownIcon"
                            name="incoTermsLocation"
                            setValue={formInputs.incoTermsLocation || ""}
                            getvalue={setDropdownData}
                          // className="dropdownOption"
                          />
                        </Col>
                      </Row>
                      <h1 className="card-title">Documents :</h1>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="scopeOfwork"
                          name="scopeOfwork"
                          label="1.1. SCOPE OF WORK"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.scopeOfwork || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.scopeOfwork && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.scopeOfwork)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="drawing"
                          name="drawing"
                          label="1.2. DRAWING"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.drawing || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.drawing && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() => handleViewFile(formInputs?.drawing)}
                          />
                        )) ||
                          "--"}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="annexures"
                          name="annexures"
                          label="1.3. ANNEXURES"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.annexures || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.annexures && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.annexures)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          id="others"
                          name="others"
                          label="1.4. OTHERS"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to false for single file selection
                          required={true}
                          onSuccessUpload={onSuccessUploadDocumentType}
                          value={formInputs?.others || ""}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        {(formInputs?.others && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(formInputs?.others)
                            }
                          />
                        )) ||
                          "--"}
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/*charges selection*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisibleCS
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibilityCS}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CS</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Charges Selection</span>
                      <span className="subHeaderTitle">Charges Selection</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisibleCS ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <h5 className="card-title commTopButtonRightLeftPadding">Select Charges</h5>
                      <Row>
                        <Col
                          xs={12}
                          md={12}
                          lg={8}
                          className="commTopButtonRightLeftPadding"
                        >
                          {getChargesSelection.map((charge) => (
                            <div className="form-check" key={charge.id}>
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`charge-${charge.id}`}
                                checked={getChargesSelected.some(
                                  (item) => item.id === charge.id
                                )}
                                onChange={() => handleChargeToggle(charge)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`charge-${charge.id}`}
                              >
                                {charge.name}
                              </label>
                            </div>
                          ))}
                        </Col>
                      </Row>


                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* other Charges table */}
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisibleCT
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibilityCT}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>

                    <Col xs={4} md={6} lg={6}>
                      <span className="headerTitle">Other Charges</span>
                      <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={4} lg={4} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisibleCT ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={HeaderTextColumns}
                          data={getChargesSelected}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination

                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}

                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "line-items" ? "show active" : ""
                    }`}
                    id="line-items"
                    role="tabpanel"
                    aria-labelledby="line-items-tab"
                  >
            {/* Line Items 06*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible6
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle">
                        Material/ Service Details
                      </span>
                    </Col>

                    <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                      <Col xs={4} md={3} lg={3} className="">
                        <button className="btnTable">Download Template</button>
                      </Col>
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={() => {
                            alert("asd");
                          }}
                        >
                          Upload Date
                        </button>
                      </Col>
                      <Col xs={4} md={2} lg={2} className="">
                        <button className="btnTable" onClick={addPOItemRow}>
                          Add PR Items
                        </button>
                      </Col>
                    </Col>
                    {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={PRLineItemInitialCol}
                          data={
                            formInputs?.rfqCreation === "PR"
                              ? getLineItemData
                              : getPRLineItemsData
                          }
                          // columns={lineItemsColumns}
                          // data={lineItemsData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "suppliers" ? "show active" : ""
                    }`}
                    id="suppliers"
                    role="tabpanel"
                    aria-labelledby="suppliers-tab"
                  >
            {/* Suppliers 07*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible7
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Suppliers * </span>
                      <span className="subHeaderTitle">
                        Material/ Service Details
                      </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={suppplierModalShow}
                        >
                          Add Supplier
                        </button>
                      </Col>
                      <Col xs={5} md={3} lg={3} className="">
                        <button
                          className="btnTable"
                          onClick={() => {
                            alert("Need to Implement");
                          }}
                        >
                          Initiate Supplier Request
                        </button>
                      </Col>
                      {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={suppliersColumns}
                          data={getSupplierData}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          // pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "tech-comm" ? "show active" : ""
                    }`}
                    id="tech-comm"
                    role="tabpanel"
                    aria-labelledby="tech-comm-tab"
                  >
            {/* Form: COMMERCIAL / TECHNICAL questionnaires - Tech & Comm
                Template tab (same as the Create RFQ tabs page) */}
            {/* COMM - Spares & Operation Maintenance 08*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible8
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>

                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Form: COMMERCIAL - Questionnaire
                      </span>
                      {/* <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span> */}
                    </Col>

                    <Col xs={12} md={5} lg={5} className="headerButtonAlign">
                      <Col xs={6} md={4} lg={4} className="">
                        <button
                          className="btnTable"
                          onClick={createDynamicformModelCOMM}
                        >
                          <i className="bi bi-plus-lg"></i>{" "}
                          {dynamicFormDataCOMM.length > 0
                            ? "Modify Form"
                            : "Generate Form"}
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="commTopButtonRightLeftPadding">
                      {/* {dynamicFormDataCOMM.length > 0 &&
                        dynamicFormDataCOMM.map((formJsonData, index) => {
                          return (
                            <RenderInputField
                              questionData={formJsonData}
                              key={index}
                            />
                          );
                        })} */}

                      {localFormDataCOMM.length > 0 &&
                        localFormDataCOMM.map((formJsonData, index) => {
                          return (
                            <RenderInputField
                              questionData={formJsonData}
                              key={index}
                            />
                          );
                        })}





                      {dynamicFormDataCOMM.length === 0 && (
                        <p className="text-center mt-4">
                          {" "}
                          Please Generate Form !!
                        </p>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Form :TECH - Spares & Operation Maintenance09*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible9
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility9}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TS</span>
                    </Col>

                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Form : TECHNICAL - Questionnaire
                      </span>
                    </Col>

                    <Col xs={12} md={5} lg={5} className="headerButtonAlign">
                      <Col xs={6} md={4} lg={4} className="">
                        <button
                          className="btnTable"
                          onClick={createDynamicformModelTECH}
                        >
                          <i className="bi bi-plus-lg"></i>{" "}
                          {dynamicFormDataTECH.length > 0
                            ? "Modify Form"
                            : "Generate Form"}
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible9 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="commTopButtonRightLeftPadding">
                      {/* {dynamicFormDataTECH.length > 0 &&
                        dynamicFormDataTECH.map((formJsonData, index) => {
                          return (
                            <RenderInputField
                              questionData={formJsonData}
                              key={index}
                            />
                          );
                        })} */}

                      {localFormDataTECH.length > 0 &&
                        localFormDataTECH.map((formJsonData, index) => {
                          return (
                            <RenderInputField
                              questionData={formJsonData}
                              key={index}
                            />
                          );
                        })}

                      {dynamicFormDataTECH.length === 0 && (
                        <p className="text-center mt-4">
                          {" "}
                          Please Generate Form !!
                        </p>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "schedule" ? "show active" : ""
                    }`}
                    id="schedule"
                    role="tabpanel"
                    aria-labelledby="schedule-tab"
                  >
            {/* Schedule - Opening / Closing date & time (moved from the
                Header Info accordion, same as the Create RFQ Schedule tab) */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Header Info</span>
                      <span className="subHeaderTitle">Header Information</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Opening Date"
                          name="openingDate"
                          id="openingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.openingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Opening Time"
                          name="openingTime"
                          id="openingTime"
                          type="time"
                          placeholder=""
                          value={getOpenCloseInput.openingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Closing Date"
                          name="closingDate"
                          id="closingDate"
                          type="date"
                          placeholder=""
                          value={getOpenCloseInput.closingDate || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Closing Time"
                          name="closingTime"
                          id="closingTime"
                          type="time"
                          placeholder=""
                          value={getOpenCloseInput.closingTime || ""}
                          onChange={onInputChangeopeningDate}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

                  </div>
                </div>
              </div>
            </div>

            <div className="pageFooter mb-4 pb-2">
              <Row className="align-items-center">
                <Col xs={12} md={3} lg={3} className="mb-2">
                  {currentTabIndex > 0 && (
                    <button
                      type="button"
                      className="btnTable"
                      onClick={goToPreviousTab}
                    >
                      <i className="bi bi-arrow-left me-2"></i> Previous
                    </button>
                  )}
                </Col>
                <Col xs={12} md={3} lg={3} className="mb-2 ms-auto text-end">
                  {!isLastTab && (
                    <button
                      type="button"
                      className="btnTable"
                      onClick={goToNextTab}
                    >
                      Next <i className="bi bi-arrow-right ms-2"></i>
                    </button>
                  )}
                </Col>
              </Row>
            </div>

          </div>
        </Col>
      </Row>
      <div className="pageFooter mb-4 pb-2">
        <Row>
          <Col
            xs={12}
            md={{ span: 2, offset: 10 }}
            lg={{ span: 2, offset: 10 }}
            className="mb-2"
          >
            <button
              disabled={disabled}
              className="btnTable"
              onClick={handleCreateManualRFQ}
            >
              Create Manual RFQ
            </button>
          </Col>
        </Row>
      </div>
      <CreateRFQSuppliers
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />

      <AddFormModal
        show={getCreateDynamicformModelShow}
        onHide={() => hideModalStatus()}
        modeldata={getFormModalData}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default CreateManualRFQ;

